import $ from "jquery"

document.addEventListener('DOMContentLoaded', function() {

  var buttons = document.querySelectorAll('.button-backstage');

  buttons.forEach(function(button) {
      button.addEventListener('click', function(e) {
          e.preventDefault();

          var target = this.getAttribute('data-target');

          var items = document.querySelectorAll('.mobile-scroll__item');
          items.forEach(function(item) {
              item.classList.remove('d-flex');
              item.classList.add('d-none');
          });

          var selectedElement = document.getElementById(target);
          selectedElement.classList.remove('d-none');
          selectedElement.classList.add('d-flex');

          buttons.forEach(function(btn) {
              btn.classList.remove('active');
          });
          this.classList.add('active');
      });
  });

});
